(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('loading', {
            templateUrl: 'app/components/loading/loading.html',
            controller: loadingController,
            bindings: {
                isLoading: '=',
                type: '@?', // 'bars' or 'spinner'
                text: '@?'
            }
        });

    /** @ngInject */
    function loadingController() {
        var $ctrl = this;
        $ctrl.type = $ctrl.type || 'bars';
        $ctrl.text = $ctrl.text || '';
    }
})();
